import { inject, Pipe } from '@angular/core';
import { Store } from '@ngxs/store';
import { CustomObject } from '@shared/modules/custom-objects/custom-objects.types';
import { ObjectsManagerState } from 'app/modules/settings/objects-manager/state/state';

@Pipe({ name: 'jupiterFaceValue', standalone: true })
export class FaceValuePipe {
  store = inject(Store);

  private get objects(): CustomObject[] {
    return this.store.selectSnapshot(ObjectsManagerState.get);
  }

  transform(value: any, relatedTo: string, context?: any): string {
    if (!value) {
      return '';
    }

    return this.getFaceValue(value, context?.relatedToObject.name ?? relatedTo);
  }

  private getFaceValue(value: any, relatedTo: string): string {
    const object = this.objects.find((x) => x.name === relatedTo);

    if (!object) {
      return '';
    }

    if (object.search_custom_field_id) {
      const field = object.fields.find((x) => x.id === object.search_custom_field_id);
      return value[field.name] || '';
    }

    return value?.title || value?.name || value?.label || '';
  }
}
